import { useLoader } from '@react-three/fiber';
import { FBXLoader } from 'three/examples/jsm/loaders/FBXLoader.js';
import { TextureLoader } from 'three';
import * as THREE from 'three';

export default function GrassModel({ url, position = [0, 0, 0], scale = 1 }) {
  const fbx = useLoader(FBXLoader, url);
  const texture = useLoader(TextureLoader, '/textures/2.jpg'); // Make sure this path matches your public folder

  // Assign the texture material to all meshes in the FBX
  fbx.traverse((child) => {
    if (child.isMesh) {
      child.material = new THREE.MeshStandardMaterial({ map: texture });
      child.castShadow = true;
      child.receiveShadow = true;
    }
  });

  return (
    <primitive
      object={fbx}
      position={position}
      scale={scale}
      castShadow
      receiveShadow
    />
  );
}